import DashBoardNav from '@/layout/DashBoardNav'

export default [{
  path: '/SmartleadsBusiness',
  component: DashBoardNav ,
  children: [
    {
      path: '/LayerBusinessMiniDash',
      name: 'filterMiniDash',
      component: () => import('@/components/layer/LayerBusinessMiniDash'),
      props: true
    },


    {path: '/datanavigator/:layer', name: 'datanavigator', component: () => import('@/components/filter/DataNavigator')}
  ]
}]
